import React from 'react';

import { connectWithStore } from '@common/connectWithStore';
import {
  EditUserPassword,
  EditUserPasswordDispatchProps,
  EditUserPasswordOwnProps,
  EditUserPasswordStateProps,
} from '@react/Pages/AccountSettingsPage/UserDetails/EditUserPassword/EditUserPassword';
import { getUserDetailsState } from '@redux/ducks/userDetails/userDetails';
import {
  changePassword,
  getIsAlertOpen,
  getIsLoading,
  getTrace,
  hideAlert,
} from '@redux/ducks/userDetails/editUserPassword';

const mapStateToProps = (state): EditUserPasswordStateProps => {
  const { user } = getUserDetailsState(state);

  return {
    user,
    trace: getTrace(state),
    isAlertOpen: getIsAlertOpen(state),
    isLoading: getIsLoading(state),
  };
};

const mapDispatchToProps: EditUserPasswordDispatchProps = {
  changePassword,
  hideAlert,
};

export const EditUserPasswordContainer: React.FC<EditUserPasswordOwnProps> = connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(EditUserPassword);
